import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[appIntersectionAnimate]'
})
export class IntersectionAnimateDirective
  implements AfterViewInit, OnDestroy {

  @Input() extraClass: string = '';
  @Input() isAnimateActive: boolean = true;

  private observer!: IntersectionObserver;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {

      if (this.isAnimateActive) {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          const ratio = entry.intersectionRatio;

          const extra = this.extraClass ? '_' + this.extraClass : '';

          if (ratio >= 0.9) {
            this.addClass('perspective-100' + extra);
            this.removeClass('perspective-50' + extra);
            this.removeClass('perspective-25' + extra);
          } else if (ratio >= 0.5 && ratio < 0.9) {
            this.addClass('perspective-50' + extra);
            this.removeClass('perspective-100' + extra);
            this.removeClass('perspective-25' + extra);
          } else if (ratio >= 0.25 && ratio < 0.5) {
            this.addClass('perspective-25' + extra);
            this.removeClass('perspective-100' + extra);
            this.removeClass('perspective-50' + extra);
          }
        },
        {
          threshold: [0.15, 0.5, 1]
        }
      );

      this.observer.observe(this.el.nativeElement);
      }
    }
  }

  removeClass(className: string) {
    this.renderer.removeClass(this.el.nativeElement, className);
  }

  private addClass(className: string) {
    this.renderer.addClass(this.el.nativeElement, className);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
